/**
 * The transition page's right-hand panel (Bridge "Right panel", 271:1667): a
 * label for what's open and Hide, around it (QuestionsPanel or CostFigures).
 * One thing at a time, no tabs: the page's action items open each. The bar
 * stays put; everything under it scrolls as one.
 */
import type { ReactNode } from 'react'
import { Button } from '../ui'
import SvgIcon from './SvgIcon'

export default function SidePanel({ title, onHide, children }: {
  title: string
  onHide: () => void
  children: ReactNode
}) {
  return (
    <aside data-tour="panel" className="relative flex h-full w-[544px] shrink-0 flex-col gap-6 border-l border-border-subtle p-4">
      <div className="flex items-center justify-between border-b border-border-subtle pb-3">
        <span className="rounded-md bg-secondary px-4 py-2 text-base font-medium leading-5 text-foreground">{title}</span>
        <Button variant="outline" onClick={onHide} className="h-10 min-w-20 gap-2 rounded-[6px] border-input px-4 text-sm leading-4 shadow-none">
          Hide <SvgIcon src="/transit/icon-hide.svg" width={16} height={16} />
        </Button>
      </div>
      {/* scroll-bridge: the thin primary scrollbar (index.css), in the panel's
          gutter. Nothing in it shrinks: it scrolls instead, or a card that
          clips its content (overflow-hidden, for a shimmer) gets squashed. */}
      <div className="scroll-bridge -mr-3 flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto pr-3 [&>*]:shrink-0">
        {children}
      </div>
    </aside>
  )
}
